import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container10">
          <h2 className="thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="testimonial17-text37">Testimonials</span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="testimonial17-text30">
                  I had a wonderful stay at this renovated apartment in
                  Wimereux. The location was perfect, just a short walk from the
                  town center and the beach. The apartment was clean, cozy, and
                  had everything we needed for a comfortable stay.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card1"
              >
                <div className="testimonial17-container12">
                  <img
                    alt={props.author1Alt}
                    src={props.author1Src}
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container13">
                    <strong className="thq-body-large">
                      {props.author1Name ?? (
                        <Fragment>
                          <span className="testimonial17-text28">
                            Sophie L.
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text34">
                            Travel Blogger
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text14 thq-body-small">
                  {props.review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text26">5 stars</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card2"
              >
                <div className="testimonial17-container14">
                  <img
                    alt={props.author2Alt}
                    src={props.author2Src}
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container15">
                    <strong className="thq-body-large">
                      {props.author2Name ?? (
                        <Fragment>
                          <span className="testimonial17-text27">Marc P.</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text24">
                            Frequent Traveler
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text17 thq-body-small">
                  {props.review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text35">
                        Great place to relax and unwind. The apartment is
                        beautifully decorated and well-equipped. I enjoyed my
                        morning coffee on the private terrace. Will definitely
                        be back!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card3"
              >
                <div className="testimonial17-container16">
                  <img
                    alt={props.author3Alt}
                    src={props.author3Src}
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container17">
                    <strong className="thq-body-large">
                      {props.author3Name ?? (
                        <Fragment>
                          <span className="testimonial17-text36">Emma S.</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text29">
                            Family Vacationer
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text20 thq-body-small">
                  {props.review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text32">
                        Perfect for a family getaway. The kids loved having
                        their own room with the twin beds. The proximity to the
                        beach made it easy for us to enjoy the sun and sand.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card4"
              >
                <div className="testimonial17-container18">
                  <img
                    alt={props.author4Alt}
                    src={props.author4Src}
                    className="testimonial17-image4"
                  />
                  <div className="testimonial17-container19">
                    <strong className="thq-body-large">
                      {props.author4Name ?? (
                        <Fragment>
                          <span className="testimonial17-text33">
                            Alexandre D.
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author4Position ?? (
                        <Fragment>
                          <span className="testimonial17-text31">
                            Pet Owner
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text23 thq-body-small">
                  {props.review4 ?? (
                    <Fragment>
                      <span className="testimonial17-text25">
                        Thank you for allowing pets! Our furry friend felt right
                        at home. The apartment was pet-friendly and the
                        surrounding area was great for walks. Highly recommend.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  author1Src:
    'https://images.unsplash.com/photo-1558624232-75ee22af7e67?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  author2Position: undefined,
  review4: undefined,
  review1: undefined,
  author2Name: undefined,
  author4Src:
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  author1Name: undefined,
  author3Position: undefined,
  content1: undefined,
  author3Src:
    'https://images.unsplash.com/photo-1440589473619-3cde28941638?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  author4Position: undefined,
  author4Alt: 'Image of Alexandre D.',
  author2Alt: 'Image of Marc P.',
  review3: undefined,
  author4Name: undefined,
  author2Src:
    'https://images.unsplash.com/photo-1728887823143-d92d2ebbb53a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NDIwMjk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  author3Alt: 'Image of Emma S.',
  author1Alt: 'Image of Sophie L.',
  author1Position: undefined,
  review2: undefined,
  author3Name: undefined,
  heading1: undefined,
}

Testimonial17.propTypes = {
  author1Src: PropTypes.string,
  author2Position: PropTypes.element,
  review4: PropTypes.element,
  review1: PropTypes.element,
  author2Name: PropTypes.element,
  author4Src: PropTypes.string,
  author1Name: PropTypes.element,
  author3Position: PropTypes.element,
  content1: PropTypes.element,
  author3Src: PropTypes.string,
  author4Position: PropTypes.element,
  author4Alt: PropTypes.string,
  author2Alt: PropTypes.string,
  review3: PropTypes.element,
  author4Name: PropTypes.element,
  author2Src: PropTypes.string,
  author3Alt: PropTypes.string,
  author1Alt: PropTypes.string,
  author1Position: PropTypes.element,
  review2: PropTypes.element,
  author3Name: PropTypes.element,
  heading1: PropTypes.element,
}

export default Testimonial17
